import { CalendarOutlined } from "@ant-design/icons";

const CalendarHeader = () => {
  return (
    <h2 className="header-section-title">
      <CalendarOutlined rev={undefined} />
      <span style={{ marginLeft: "5px" }}>Calendario</span>
    </h2>
  );
};

export default CalendarHeader;
